import configuration from './configuration';
import { Configuration } from './services/ConfigurationService';

const configurationDev: Configuration = {

    APIBaseURL: '/api'
}

export default {configuration, ...configurationDev};